<template>
    <div class="s-img">
        <img :src="src" @click="view">
        <div class="s-img-preview" @click="view">
            <a-icon type="eye" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "s-img",
        props: {
            src: String
        },
        data() {
            return {

            }
        },
        methods: {
            view() {
                this.$store.dispatch("showImgList", [{ url: this.src }]);
            }
        }
    }
</script>

<style scoped lang="less">
    .s-img {
        position: relative;
        width: 100px;
        height: 50px;
        line-height: 1;
        cursor: pointer;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        &:hover {
            .s-img-preview {
                display: flex;
            }
        }
    }
    .s-img-preview {
        display: none;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.4);
        font-size: 24px;
        color: rgba(255,255,255,0.7);
    }
</style>
